import { v4 as uuidv4 } from 'uuid'

function generateQuickId() {
  const randomString = uuidv4()
  return randomString
}

const id = generateQuickId()

export function getEnvironmentInfo() {
  const deviceId = (() => {
    let id = localStorage.getItem('device_id')
    if (!id) {
      id = generateQuickId()
      localStorage.setItem('device_id', id)
    }
    return id
  })()

  const sessionId = (() => {
    let id = sessionStorage.getItem('session_id')
    if (!id) {
      id = generateQuickId()
      sessionStorage.setItem('session_id', id)
    }
    return id
  })()

  const pageUrl = window.location.href
  const pageReferrer = document.referrer

  const userAgent = navigator.userAgent
  const deviceType = /Mobi|Android/i.test(userAgent)
    ? 'mobile'
    : /Tablet|iPad/i.test(userAgent)
    ? 'tablet'
    : 'desktop'

  let os = 'unknown'
  // Check Android first since Android user agents often contain "Linux"
  if (/Android/.test(userAgent)) os = 'Android'
  else if (/Windows NT/.test(userAgent)) os = 'Windows'
  else if (/iPhone|iPad|iPod/.test(userAgent)) os = 'iOS'
  else if (/Mac OS X/.test(userAgent) && !/iPhone|iPad|iPod/.test(userAgent))
    os = 'macOS'
  else if (/Linux/.test(userAgent)) os = 'Linux'

  let browser = 'unknown'
  // Improved browser detection - check more specific patterns first
  if (/Edg\//.test(userAgent)) browser = 'Edge'
  else if (/EdgiOS/.test(userAgent)) browser = 'Edge'
  else if (/CriOS/.test(userAgent)) browser = 'Chrome'
  else if (/Chrome\//.test(userAgent) && !/CriOS/.test(userAgent))
    browser = 'Chrome'
  else if (/FxiOS/.test(userAgent)) browser = 'Firefox'
  else if (/Firefox\//.test(userAgent)) browser = 'Firefox'
  else if (
    /Safari\//.test(userAgent) &&
    !/Chrome|CriOS|FxiOS|EdgiOS/.test(userAgent)
  )
    browser = 'Safari'
  else if (/MSIE|Trident/.test(userAgent)) browser = 'IE'

  const timestamp = new Date().toISOString()
  return {
    id,
    device_id: deviceId,
    session_id: sessionId,
    page_url: pageUrl,
    page_referrer: pageReferrer,
    device_type: deviceType,
    os,
    browser,
    timestamp,
  }
}
